// Template Generated by DataExtraction.py at 1716507313

import TransferEnglish6 from "../../Forms/Transfer/Transfer_English6.png";
import TransferEnglish6Labels from "../../Labels/Transfer/Transfer_English6.json";
import TransferFrench6 from "../../Forms/Transfer/Transfer_French6.png";
import TransferFrench6Labels from "../../Labels/Transfer/Transfer_French6.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, drawTextScaled as drawTextAtPos
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import { t } from "i18next";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench6Labels : TransferEnglish6Labels;
    const formImage = isFrench ? TransferFrench6 : TransferEnglish6;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    // Drawing the form
    // TODO implement fields

    // drawTextAtPos(doc, 40, t("Transfer Department"), 35 / 3.38, 583 / 3.38, 184 / 3.38);
    // drawTextAtPos(doc, 40, t("800-246-1203"), 335 / 3.38, 583 / 3.38, 114 / 3.38);
    // drawTextAtPos(doc, 40, t("905-331-9977"), 507 / 3.38, 583 / 3.38, 114 / 3.38);

    drawText(t("Transfer Department"), "rPromotorDepartment")
    drawText(t("800-246-1203"), "rPromotorPhone")
    drawText(t("905-331-9977"), "rPromotorFax")

}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TransferFrench6Labels : TransferEnglish6Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];



    return signers;
}

export default {
    generate,
    signatureDefinitions
}
